import { FormattedMessage } from 'react-intl';

export const LastVisionCheckTitle = () => (
  <span data-testid="last-vision-check-vp-title">
    <FormattedMessage id="vp.lastVisionCheck.title" />
  </span>
);